<template>
    <div class="home">
        <div class="navbar">
            <div class="nav_pi">
                <img class="nav_icon" src="../assets/icn.png" alt="ICN Logo" />
                <p class="nav_txt">Ifechukwu</p>
            </div>
            <div ref="navLinks" class="nav_links" :class="{ show: isShow }">
                <a class="nav_link_home" href="#home" @click="handleNavClick">Home</a>
                <a class="nav_link_about" href="#about" @click="handleNavClick">About</a>
                <a class="nav_link_projects" href="#projects" @click="handleNavClick">Projects</a>
                <a class="nav_link_contact" href="#contact" @click="handleNavClick">Contact</a>
                <a class="nav_link_resume" href="https://drive.google.com/file/d/1n7HOM7h1QilqUTyBfi01fpFF9D1F7oKI/view?usp=drive_link" target="_blank" @click="handleNavClick"><p class="nav_link_resume_text">Resume</p></a>
                <a class="nav_link_movinity" href="https://movinity.ifechukwunwachukwu.com/" target="_blank" @click="handleNavClick"><p class="nav_link_movinity_text">Movinity</p></a>
            </div>
            <img class="hamburger_icon" src="../assets/hamburger_menu_4.png" alt="Menu" @click="toggleMenu" />
        </div>
        <HeroSection />
        <AboutSection />
        <ProjectsSection />
        <CallToActionSection />

        <div class="footer_section">
            <div class="footer_left">
                <p class="footer_text">2025. ICN. All rights reserved.</p>
            </div>

            <div class="footer_right">
                <p class="footer_text">Made with ❤️ using Vue.js</p>
            </div>
        </div>
    </div>
</template>

<script>
    import HeroSection from "../components/HeroSection.vue";
    import AboutSection from "../components/AboutSection.vue";
    import ProjectsSection from "../components/ProjectsSection.vue";
    import CallToActionSection from "../components/CallToActionSection.vue";
    import { useRoute } from "vue-router";
    import { ref, onMounted, onBeforeUnmount, watch } from 'vue';

    export default{
        name: "HomeView",
        components: {
            HeroSection,
            AboutSection,
            ProjectsSection,
            CallToActionSection,
        },
        setup () {
            const isShow = ref(false);
            const navLinks = ref(null);

            const toggleMenu = () => {
                isShow.value = !isShow.value;
            };

            const handleNavClick = () => {
                if (window.innerWidth <= 600) {
                    isShow.value = false; 
                }
            };

            const handleClickOutside = (event) => {
                if (
                    isShow.value &&
                    navLinks.value &&
                    !navLinks.value.contains(event.target) &&
                    !event.target.closest(".hamburger_icon")
                ) {
                    isShow.value = false;
                }
            };

            const route = useRoute();
            const updateActiveNavLink = () => {
                const links = {
                    home: document.querySelector('.nav_link_home'),
                    about: document.querySelector('.nav_link_about'),
                    projects: document.querySelector('.nav_link_projects'),
                    contact: document.querySelector('.nav_link_contact'),
                }

                Object.values(links).forEach(link => link?.classList.remove('selected_nav'));
                if (route.hash === '#about') {
                    links.about?.classList.add('selected_nav');
                } else if (route.hash === '#projects') {
                    links.projects?.classList.add('selected_nav');
                } else if (route.hash === '#contact') {
                    links.contact?.classList.add('selected_nav');
                } else {
                    links.home?.classList.add('selected_nav');
                }
            };

            onMounted(() => {
                updateActiveNavLink();
                document.addEventListener("click", handleClickOutside);
            });

            onBeforeUnmount(() => {
                document.removeEventListener("click", handleClickOutside);
            });

            watch(() => route.hash, () => {
                updateActiveNavLink();
            });

            return {
                isShow,
                toggleMenu,
                handleNavClick,
                navLinks
            };  
        }
    };
</script>

<style scoped>
    .home {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .navbar {
        width: 100%;
        position: fixed;
        background-color: rgb(73, 2, 46);
        /* background-color: #16010E; */
        /* background-color: rgb(73, 2, 46); */
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 50px;
        padding-right: 50px;
        z-index: 1000;
    }

    .hamburger_icon{
        width: 35px;
        height: 35px;
        cursor: pointer;
        display: none;
    }

    .nav_pi{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
    }

    .nav_icon{
        width: 45px;
        height: 45px;
        /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); */
    }

    .nav_txt {
        color: rgb(244, 187, 222);
        font-size: 24px;
        font-weight: bold;
    }

    .nav_links {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 50px;
    }

    .nav_link_resume_text{
        position: relative;
        color: rgb(73, 2, 46);
        font-size: 16px;
        font-weight: 600;
        z-index: 5;
    }

    .nav_link_movinity_text{
        position: relative;
        color: aliceblue;
        font-size: 16px;
        font-weight: 600;
        z-index: 5;
    }

    .nav_link_resume{
        background-color: rosybrown;
        padding-top: 7px;
        padding-bottom: 7px;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 10px;
        border: 2px solid black;
        text-decoration: none;
    }

    .nav_link_movinity{
        background-color: #03132a;
        padding-top: 7px;
        padding-bottom: 7px;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 10px;
        border: 2px solid black;
        text-decoration: none;
    }

    .nav_link_movinity::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform: scaleY(0);
        transform-origin: bottom;
        transition: transform 0.4s ease;
        background-color: #0A2351;
        border-radius: 10px;
    }

    .nav_link_resume::before{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform: scaleY(0);
        transform-origin: bottom;
        transition: transform 0.4s ease;
        background-color: rgb(237, 180, 180);
        border-radius: 10px;
    }

    .nav_link_movinity:hover::before, .nav_link_resume:hover::before {
        transform: scaleY(1);
    }

    .nav_link_home, .nav_link_about, .nav_link_projects, .nav_link_contact {
        color: #A5A5A5;
        text-decoration: none;
        font-size: 18px;
        position: relative;
    }

    .selected_nav {
        color: rgb(244, 187, 222);
        text-decoration: none;
        font-size: 18px;
        position: relative;
    }

    .nav_link_home::after, .nav_link_about::after, .nav_link_projects::after, .nav_link_contact::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 0;
        height: 2px;
        background-color: #A5A5A5;
        transition: width 0.3s ease;
    }

    .nav_link_home:active::after, .nav_link_about:active::after, .nav_link_projects:active::after, .nav_link_contact:active::after, 
    .nav_link_home:hover::after, .nav_link_about:hover::after, .nav_link_projects:hover::after, .nav_link_contact:hover::after {
        width: 60%; 
    }

    .selected_nav::after{
        width: 100%;
        background-color: rgb(244, 187, 222);
    }

    .footer_section {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 20px 50px;
        background-color: rgb(73, 2, 46);
        color: rgb(244, 187, 222);
        position: fixed;
        bottom: 0;
        z-index: 1000;
    }

    @keyframes bounce {
        0%, 100% {
            transform: translateY(0);
        }
        30% {
            transform: translateY(-20px);
        }
        50% {
            transform: translateY(0);
        }
    }

    @keyframes shake {
        0% {
        transform: translateX(0);
        }
        25% {
        transform: translateX(-5px);
        }
        50% {
        transform: translateX(5px);
        }
        75% {
        transform: translateX(-5px);
        }
        100% {
        transform: translateX(0);
        }
    }

    @keyframes shake2 {
        0% {
        transform: translateX(0);
        }
        25% {
        transform: translateX(5px);
        }
        50% {
        transform: translateX(-5px);
        }
        75% {
        transform: translateX(5px);
        }
        100% {
        transform: translateX(0);
        }
    }

    .nav_link_movinity {
        animation: shake2 3s infinite;
        transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
    }

    .nav_link_resume {
        animation: shake 3s infinite;
        transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
    }

    @media (max-width: 1200px) {
        .navbar {
            padding-top: 20px;
            padding-bottom: 20px;
            padding-left: 30px;
            padding-right: 30px;
        }

        .nav_icon {
            width: 40px;
            height: 40px;
        }

        .nav_txt {
            font-size: 22px;
        }

        .nav_links {
            gap: 25px;
        }
        
    }

    @media (max-width: 768px) {
        .navbar {
            padding-top: 20px;
            padding-bottom: 20px;
            padding-left: 30px;
            padding-right: 30px;
        }

        .nav_icon {
            width: 35px;
            height: 35px;
        }

        .nav_txt {
            font-size: 20px;
        }

        .hamburger_icon {
            display: block;
        }

        .nav_links {
            position: absolute;
            top: 80px;
            right: 0;
            background-color: rgb(73, 2, 46);
            width: 100%;
            padding: 20px 0;
            flex-direction: column;
            align-items: center;
            gap: 15px;
            transform: translateY(-200%);
            opacity: 0;
            transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
        }

        .nav_links.show {
            display: flex;
            transform: translateY(0);
            opacity: 1;
        }

        .footer_section {
            width: 100%;
            justify-content: center;
            padding: 20px 30px;
        }

        .footer_right{
            display: none;
        }
    }
</style>
